import { IToolSearchResult, TToolStatus } from 'types/quoteEditor.types';
import CreateNewToolButton from '../CreateNewToolButton/CreateNewToolButton';
import ToolSearchResultRow from './ToolSearchResultRow/ToolSearchResultRow';
import './ToolSearchResults.scss';

interface IToolSearchResults {
  results: IToolSearchResult[];
  onSelectTool: (tool: IToolSearchResult) => void;
  onCreateNew: () => void;
}

/**
 * Tabla de resultados de búsqueda con características como pills y estado con dot de color.
 * Cada fila es clickeable para seleccionar la herramienta.
 */
const ToolSearchResults = ({ results, onSelectTool, onCreateNew }: IToolSearchResults) => {
  const statusLabels: Record<TToolStatus, string> = {
    forQuote: 'Para cotizar',
    active: 'Prendido',
    inactive: 'Apagado'
  };

  const columns = ['Modelo', 'Características', 'SKU', 'Marca', 'Estado'];

  return (
    <div className="toolSearchResults">
      <div className="tableWrapper">
        <table className="toolSearchResultsTable">
          <thead>
            <tr>
              {columns.map(column => (
                <th key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {results.map(tool => (
              <ToolSearchResultRow key={tool.id} tool={tool} statusLabels={statusLabels} onSelectTool={onSelectTool} />
            ))}
          </tbody>
        </table>
      </div>
      <CreateNewToolButton onClick={onCreateNew} />
    </div>
  );
};

export default ToolSearchResults;
